import { Box, Typography } from "@mui/material";
import axios from "axios";
import { error } from "console";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const AcceptablePolicy = ({
  isMediumScreen,
  data,
}: {
  isMediumScreen: any;
  data: any;
}) => {


  return (
    <>
      <div
        className="tabs-content lg:py-[60px]  py-[32px] lg:px-[60px] px-[16px] rounded-[40px] bg-[#0E0E104D] border-[1px] border-[#3F3F4B] terms-condition-wrapper"
        dangerouslySetInnerHTML={{
          __html: data?.description,
        }}
      ></div>
    </>
  );
};
